/**
 * オオカミの森 — スクロールインアニメーション
 * IntersectionObserver で要素が画面内に入ったら .is-visible を付与
 */
(function() {
  if (!('IntersectionObserver' in window)) {
    // IE等 非対応ブラウザは全部表示
    document.querySelectorAll('.ookami-anim, .ookami-kpi__card, .ookami-axes__card, .ookami-testimonials__card, .tabirou-values__card, .ookami-news__row, .tabirou-story__heading, .tabirou-story__divider').forEach(function(el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.1
  });

  // 対象セレクター
  var selectors = [
    '.ookami-anim',
    '.ookami-kpi__card',
    '.ookami-axes__card',
    '.ookami-testimonials__card',
    '.tabirou-values__card',
    '.ookami-news__row',
    '.tabirou-story__heading',
    '.tabirou-story__divider',
    '.ookami-creators-preview__item',
    '.ookami-product-card'
  ];

  selectors.forEach(function(sel) {
    var elements = document.querySelectorAll(sel);
    elements.forEach(function(el, idx) {
      // スタガード遅延
      el.style.transitionDelay = (idx % 6) * 80 + 'ms';
      observer.observe(el);
    });
  });

  // フォトストリップ自動スクロール
  var strip = document.querySelector('.ookami-photo-strip__track');
  if (strip && strip.children.length > 4) {
    // アイテムを複製してループ感を出す
    var items = strip.innerHTML;
    strip.innerHTML = items + items;
    strip.classList.add('ookami-photo-strip__track--auto');
  }
})();
